import * as React from "react";
const USBasedSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.02}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.04}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#EF4136"
      d="m39.12 38.268-5.477-5.476a9.636 9.636 0 1 0-1.237 1.237l5.476 5.477a.876.876 0 1 0 1.238-1.238ZM18.376 26.637a7.875 7.875 0 1 1 7.875 7.875 7.884 7.884 0 0 1-7.875-7.875Z"
    />
  </svg>
);
export default USBasedSVG;
